/*
  art-header-cta — setzt den Eintrag des hervorgehobenen Kopf-Knopfs als ERSTEN Punkt in Horizons
  Handy-Menü.

  Der Eintrag steht als <template data-art-header-cta-drawer> im Kopf (snippets/art-header-cta.liquid).
  Horizons Menü-Dateien bleiben unangetastet: dieses Skript klont nur die Vorlage in die vorhandene
  Liste. Es läuft beim Laden und erneut bei `shopify:section:load`, denn der Theme-Editor ersetzt den
  Kopf beim Bearbeiten, ohne Skripte neu auszuführen. Steht der Eintrag schon in der Liste, passiert
  nichts; ohne Vorlage (Knopf ausgeschaltet) ebenso.

  Außerhalb des Editors holt Horizon den Kopf kurz nach dem Laden einmal neu (assets/section-hydration.js
  über die Section Rendering API) und gleicht alle Teile mit data-hydration-key an das Server-Markup an,
  auch die Schublade. Der eingesetzte Eintrag fällt dabei heraus. Deshalb beobachtet das Skript den
  Kopf-Abschnitt und setzt den Eintrag nach jeder Änderung wieder ein, wenn er fehlt.
*/
(() => {
  const TEMPLATE = 'template[data-art-header-cta-drawer]';
  const LIST = '.header__drawer .menu-drawer__menu.has-submenu';
  const MARK = '[data-art-header-cta-drawer-item]';
  const SECTION = '.shopify-section';

  function insert(scope) {
    const root = scope && typeof scope.querySelector === 'function' ? scope : document;
    const tpl = root.querySelector(TEMPLATE) || document.querySelector(TEMPLATE);
    const list = root.querySelector(LIST) || document.querySelector(LIST);
    if (!tpl || !tpl.content || !list) return;
    if (list.querySelector(MARK)) return;
    const item = tpl.content.firstElementChild;
    if (!item) return;
    list.insertBefore(item.cloneNode(true), list.firstElementChild);
  }

  const beobachtet = new WeakSet();

  function watch(scope) {
    if (typeof MutationObserver !== 'function') return;
    const root = scope && typeof scope.querySelector === 'function' ? scope : document;
    const tpl = root.querySelector(TEMPLATE) || document.querySelector(TEMPLATE);
    const section = tpl && typeof tpl.closest === 'function' ? tpl.closest(SECTION) : null;
    if (!section || beobachtet.has(section)) return;
    beobachtet.add(section);
    new MutationObserver(() => insert(section)).observe(section, { childList: true, subtree: true });
  }

  if (window.__artHeaderCta) {
    insert(document);
    return;
  }
  window.__artHeaderCta = true;

  const start = () => {
    insert(document);
    watch(document);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (ev) => {
    insert(ev.target);
    watch(ev.target);
  });
})();
